import gql from 'graphql-tag'

const getCenters = schema => gql`query getCenters {
    ${schema}_donation_center__c {
      id
      sfid
      city__c
      state__c
      zipcode__c
      name,
      publication_date__c,
      center_url_name__c,
      is_center_hidden_from_donors__c
    }
  }`

export default getCenters
